import { NestedCheckGroup } from 'src/app/components/wizards/nested-checks.dialog.component'
import { eventListTabs, getDefaultEventListTabNames } from 'globals/store/share.event-lists.data'

const pageDisplayChecks: NestedCheckGroup = {
  groupName: 'Page display options',
  checkboxes: [{
    label: 'Account name',
    id: 'accountName'
  }, {
    label: 'Event list name',
    id: 'eventListName'
  }, {
    label: 'Description',
    id: 'description',
  }, {
    label: 'Subscribe to calendar link',
    id: 'calendar',
  }, {
    label: 'Made with Joi logo',
    id: 'madeWithJoi'
  }]
}

const eventDisplayChecks: NestedCheckGroup = {
  groupName: 'Event display options',
  checkboxes: [{
    label: 'Date text',
    id: 'dates'
  }, {
    label: 'Link to published page',
    id: 'publishLinks'
  }, {
    label: 'CTA Links',
    id: 'CTALinks',
  }, {
    label: 'Publish page main venue',
    id: 'mainVenue'
  },
]
}


const generalInstructions = { instructions: { title: 'General display options', text: 'Choose what information appears on the page.'} }
const tabInstructions = { instructions: { title: 'Tab display options', text: 'Choose which tabs display in your event list.'} }

const defaultTabs = getDefaultEventListTabNames()
export const eventListDisplayOptions: NestedCheckGroup[] = [
  generalInstructions,
  pageDisplayChecks,
  eventDisplayChecks,
  tabInstructions,
  {
    groupName: 'Upcoming Events tab',
    tabId: eventListTabs.future,
    defaultTabName: defaultTabs.future,
    hintText: 'Future Events, Coming Soon etc.',
  },{
    groupName: 'Past Events tab',
    tabId: eventListTabs.past,
    defaultTabName: defaultTabs.past,
    hintText: 'Previous Events, Event History etc.',
  },
]